"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _withMask = _interopRequireDefault(require("../TextInput/withMask"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StyledPhoneInput = require("./StyledPhoneInput");
var _DialCodeAddon = _interopRequireDefault(require("./DialCodeAddon"));
var _ModalContext = require("../Modal/context/ModalContext");
var _excluded = ["customFormItem"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var maskHoc = (0, _withMask.default)(_StyledPhoneInput.StyledPhoneInput);
var MaskedInput = (0, _inputHOC.default)(maskHoc);
maskHoc.displayName = 'PhoneInput';
var PhoneInput = exports.default = /*#__PURE__*/function (_Component) {
  function PhoneInput(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PhoneInput);
    _this = _callSuper(this, PhoneInput, [props]);
    (0, _defineProperty2.default)(_this, "handleChange", function (e, unMaskedValue, maskedValue) {
      if (_this.props.onChange) _this.props.onChange(e, unMaskedValue, maskedValue);
    });
    (0, _defineProperty2.default)(_this, "unMask", function (maskedValue) {
      return maskedValue.replace(/\D+/g, '');
    });
    (0, _defineProperty2.default)(_this, "prepareAddonBefore", function () {
      var _this$props = _this.props,
        addonBefore = _this$props.addonBefore,
        dialCodeAddon = _this$props.dialCodeAddon,
        onDialCodeChange = _this$props.onDialCodeChange,
        defaultSelectedDialCode = _this$props.defaultSelectedDialCode;
      if (dialCodeAddon) {
        return /*#__PURE__*/_react.default.createElement(_DialCodeAddon.default, {
          dialCodeAddon: dialCodeAddon,
          onDialCodeChange: onDialCodeChange,
          defaultSelectedDialCode: defaultSelectedDialCode
        });
      } else if (addonBefore) {
        return addonBefore;
      }
    });
    return _this;
  }
  (0, _inherits2.default)(PhoneInput, _Component);
  return (0, _createClass2.default)(PhoneInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        customFormItem = _this$props2.customFormItem,
        props = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      return /*#__PURE__*/_react.default.createElement(_ModalContext.ModalContextConsumer, null, function (value) {
        return /*#__PURE__*/_react.default.createElement(MaskedInput, (0, _extends2.default)({}, props, {
          addonBefore: _this2.prepareAddonBefore(),
          type: "tel",
          unMask: _this2.unMask,
          onChange: _this2.handleChange,
          renderOnBody: value === null || value === void 0 ? void 0 : value.renderOnBody
        }));
      });
    }
  }]);
}(_react.Component);
PhoneInput.propTypes = {
  customFormItem: _propTypes.default.bool,
  addonAfter: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  addonBefore: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  disabled: _propTypes.default.bool,
  mask: _propTypes.default.array,
  placeholder: _propTypes.default.string,
  dialCodeAddon: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
    name: _propTypes.default.string,
    customData: _propTypes.default.array,
    key: _propTypes.default.string,
    valueKey: _propTypes.default.string,
    labelKey: _propTypes.default.string,
    renderCustomOption: _propTypes.default.func
  })]),
  /** 
  Works only when dialCodeAddon feature is used
  */
  handleDialCodeChange: _propTypes.default.func,
  /** 
  Works only when dialCodeAddon feature is used
  */
  defaultSelectedDialCode: _propTypes.default.string
};
PhoneInput.defaultProps = {
  customFormItem: true,
  disabled: false,
  placeholder: '(___) ___-____',
  mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  dialCodeAddon: false,
  defaultSelectedDialCode: '+90'
};